// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Package palette panel (adjacent to built-in tools; dropdown opens toward canvas). */

/* Trigger lives in the left rail (below the built-in nodes); the panel opens
   into the strip to the right of the rail. */
.YnmQxWUc9sxjM8m0RZmm {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    flex-shrink: 0;
    pointer-events: none;
}

.YnmQxWUc9sxjM8m0RZmm > * {
    pointer-events: auto;
}

.MlB6ZpNJUBoPfXzsO0zY {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 4px;
    flex-shrink: 0;
}

.Ps1OUCo73VcvUnhrGBU3 {
    flex-shrink: 0;
    padding: 8px 10px 10px;
    border-top: 1px solid rgba(255, 255, 255, 0.08);
    background-color: #1E1F23;
}

.uWWp8DC_l6t3Mw9nBGDE {
    width: 100%;
    box-sizing: border-box;
    min-height: 32px;
    padding: 8px 10px;
    border: none;
    border-radius: 4px;
    background-color: #FBAA69;
    color: #1E1F23;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.4px;
    line-height: 1.2;
    cursor: pointer;
    transition: background-color 0.15s ease;
}

.uWWp8DC_l6t3Mw9nBGDE:hover {
    background-color: #fb9a4f;
}

.uWWp8DC_l6t3Mw9nBGDE:focus-visible {
    outline: 2px solid rgba(251, 170, 105, 0.85);
    outline-offset: 2px;
}

.IPbLp4QWfsVYNxjSXozQ {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    padding: 8px;
    width: 100%;
    box-sizing: border-box;
    background-color: #1E1F23;
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 5px;
    color: #fbfcf6;
    cursor: pointer;
    transition: border-color 0.15s ease, color 0.15s ease, background-color 0.15s ease;
}

.IPbLp4QWfsVYNxjSXozQ:hover {
    background-color: #2c2d32;
}

.N3ANezycAzcqGXN7Yqo3 {
    border-color: rgba(251, 170, 105, 0.85);
    color: #FBAA69;
}

.mAmXDMf6oBOLAp8Im1zy {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 6px;
}

.WVQsU7i3oHd5AYuNtwJa {
    font-size: 1.25em;
}

.dyJbIyr77XYBbdhHk6pQ {
    font-size: 8px;
    font-weight: 700;
    letter-spacing: 0.6px;
    text-transform: uppercase;
    line-height: 1;
}

.eVSzGDeC4XielroWUBfQ {
    font-size: 10px;
    font-weight: 700;
    color: #fbfcf6;
    background-color: rgba(251, 170, 105, 0.25);
    border-radius: 8px;
    padding: 1px 6px;
    line-height: 1.2;
}

.N3ANezycAzcqGXN7Yqo3 .eVSzGDeC4XielroWUBfQ {
    background-color: rgba(251, 170, 105, 0.35);
    color: #fbfcf6;
}

.fzeJtcUX8Xt4eQ62_MTg {
    font-size: 10px;
    opacity: 0.85;
}

/* Absolutely positioned against #tools-palette-dock (the only positioned
   ancestor) so the panel opens beside the built-in rail without widening it. */
.i6SxHYiIgdMn3G8f4ysG {
    position: absolute;
    top: 0;
    left: 100%;
    margin-left: 10px;
    width: min(380px, calc(100vw - 120px));
    max-height: min(720px, calc(100vh - 170px));
    background-color: #1E1F23;
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 5px;
    box-shadow: 6px 10px 28px rgba(0, 0, 0, 0.45);
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.b7848Epd0ZnlchDQZY9k {
    flex-shrink: 0;
    font-size: 9px;
    font-weight: 700;
    letter-spacing: 0.8px;
    line-height: 1.2;
    color: rgba(255, 255, 255, 0.55);
    text-transform: uppercase;
    text-align: left;
}

.ezPg16Xe1L85ygmqQ1Xm {
    margin: 0;
    padding: 0;
}

.JSVyvWpE6OP98JhxGAMz {
    overflow-y: auto;
    padding: 6px 8px 10px;
    flex: 1;
    min-height: 0;
}

.dqAzSdCZgpqnMzNvjdGL {
    border: 1px solid rgba(255, 255, 255, 0.06);
    border-radius: 4px;
    margin-bottom: 8px;
    background-color: rgba(0, 0, 0, 0.15);
}

.dqAzSdCZgpqnMzNvjdGL:last-child {
    margin-bottom: 0;
}

.FWtB5GIVAtPY5mnsLELA {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 8px;
    cursor: pointer;
    list-style: none;
    padding: 8px 10px;
    font-size: 11px;
    font-weight: 600;
    color: rgba(251, 252, 246, 0.92);
    line-height: 1.3;
}

.FWtB5GIVAtPY5mnsLELA::-webkit-details-marker {
    display: none;
}

.McugiZ529ePknPEZpQfy {
    flex: 1;
    min-width: 0;
    word-break: break-word;
}

.McugiZ529ePknPEZpQfy[role="button"] {
    cursor: pointer;
    color: rgba(251, 170, 105, 0.95);
    text-decoration: underline;
    text-decoration-color: rgba(251, 170, 105, 0.45);
    text-underline-offset: 2px;
}

.McugiZ529ePknPEZpQfy[role="button"]:hover {
    color: #fbaa69;
    text-decoration-color: rgba(251, 170, 105, 0.85);
}

.BQhb6gR3StA4sqStXt2r {
    flex-shrink: 0;
    align-self: flex-start;
    background: transparent;
    border: 1px solid rgba(255, 255, 255, 0.22);
    border-radius: 4px;
    color: rgba(251, 252, 246, 0.92);
    padding: 4px 7px;
    cursor: pointer;
    font-size: 11px;
    line-height: 1;
}

.BQhb6gR3StA4sqStXt2r:hover {
    background: rgba(255, 255, 255, 0.08);
}

.LPVi0GCT_JoDEW3K_Lhp {
    flex-shrink: 0;
    align-self: flex-start;
    background: transparent;
    border: 1px solid rgba(255, 255, 255, 0.22);
    border-radius: 4px;
    color: rgba(251, 252, 246, 0.92);
    padding: 4px 7px;
    cursor: pointer;
    font-size: 11px;
    line-height: 1;
}

.LPVi0GCT_JoDEW3K_Lhp:hover {
    background: rgba(255, 255, 255, 0.08);
}

.agQcZHlI4GDwOOT8k_hM {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    gap: 8px;
    width: 100%;
}

.U6zpoH1n37k5SJpB4pog {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 8px;
    flex: 1;
    min-width: 0;
}

.U6zpoH1n37k5SJpB4pog .McugiZ529ePknPEZpQfy {
    flex: 1;
    min-width: 0;
}

.ZpsrJINVLNISMG44PUGw {
    flex-shrink: 0;
    font-size: 9px;
    font-weight: 700;
    color: rgba(255, 255, 255, 0.55);
    background-color: rgba(255, 255, 255, 0.08);
    border-radius: 6px;
    padding: 2px 6px;
}

.t5mq2RzHLNsfbWcgDRVQ {
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: 4px 6px 8px;
    border-top: 1px solid rgba(255, 255, 255, 0.06);
}

.FycGImEz8qwdahcu35jw {
    padding-top: 8px;
    padding-left: 8px;
}

.ge1sjrKNf2bgeZY3k7D5 {
    border-color: rgba(42, 109, 244, 0.75);
    box-shadow: 0 0 0 1px rgba(42, 109, 244, 0.35);
}

/* Header bar of the panel. Matches the dataset palette's \`.panelHeader\` so both
   panels put their title on the same left inset and baseline. */
.iq3g6FF70YOZdNLGJKQB {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    min-height: 34px;
    padding: 0 10px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    align-items: center;
    justify-content: flex-start;
}

.DuZbmPliiOWPewtNq_Kf {
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    padding: 6px 12px;
    border-radius: 4px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    background: rgba(0, 0, 0, 0.2);
    color: #fbfcf6;
    cursor: pointer;
}

.DuZbmPliiOWPewtNq_Kf:hover {
    background: rgba(255, 255, 255, 0.08);
}

.fdhIUCw0mQf3xboK2Bj1 {
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.3px;
    padding: 6px 10px;
    border-radius: 4px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    background: rgba(0, 0, 0, 0.15);
    color: rgba(251, 252, 246, 0.9);
    cursor: pointer;
}

.fdhIUCw0mQf3xboK2Bj1:hover {
    background: rgba(255, 255, 255, 0.06);
}

.yW6XRKGl8rrzGl8kA2_V {
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.3px;
    padding: 6px 10px;
    border-radius: 4px;
    cursor: pointer;
    border: 1px solid rgba(251, 170, 105, 0.45);
    background: rgba(251, 170, 105, 0.12);
    color: #fbaa69;
}

.yW6XRKGl8rrzGl8kA2_V:hover {
    background: rgba(251, 170, 105, 0.2);
}

.TguIX9_P1mqDfyc9bHe3 {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    gap: 8px;
    min-height: 45px;
}

.K2y80C0udB3eVNwNQCTw {
    width: 45px;
    flex-shrink: 0;
    cursor: grab;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 8px 0;
    position: relative;
    border-radius: 4px;
    border: 1px solid rgba(255, 255, 255, 0.06);
    background: rgba(0, 0, 0, 0.12);
}

.J5HqIbTNNSKGDYmuWkbE {
    overflow: visible;
}

.rM8iF5Z5KjQLnnHTutlw {
    position: absolute;
    top: -7px;
    left: -7px;
    z-index: 2;
    width: 20px;
    height: 20px;
    padding: 0;
    border: none;
    border-radius: 50%;
    background: transparent;
    color: #ff453a;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    line-height: 1;
    filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.45));
}

.rM8iF5Z5KjQLnnHTutlw:hover {
    color: #ff6961;
}

.rM8iF5Z5KjQLnnHTutlw:active {
    transform: scale(0.94);
}

.lbLJ3nS7DpEUFt2kxb9x {
    font-size: 1.5em;
    color: #fbfcf6;
}

.hQ1y1fTUT1CZ22sdFNnn {
    position: absolute;
    bottom: 2px;
    right: 2px;
    font-size: 7px;
    font-weight: 700;
    letter-spacing: 0.3px;
    color: #fbfcf6;
    background-color: #2a6df4;
    padding: 1px 3px;
    border-radius: 3px;
    line-height: 1;
    pointer-events: none;
}

.K2y80C0udB3eVNwNQCTw:active {
    cursor: grabbing;
}

.SQJjSyR2k8POFlvKeTYT {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 4px;
    min-width: 0;
    background: transparent;
    border: 1px solid transparent;
    border-radius: 4px;
    color: inherit;
    cursor: pointer;
    padding: 4px 6px;
    text-align: left;
}

.SQJjSyR2k8POFlvKeTYT:hover {
    background: rgba(255, 255, 255, 0.06);
    border-color: rgba(255, 255, 255, 0.08);
}

.k04FpgQydeu5GAO53R0E {
    font-size: 11px;
    font-weight: 600;
    color: rgba(251, 252, 246, 0.92);
    line-height: 1.2;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
}

.vLRsIeDKZLQOKkbPhr1P {
    font-size: 8px;
    font-weight: 700;
    letter-spacing: 0.4px;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.68);
    background: rgba(255, 255, 255, 0.1);
    border-radius: 4px;
    padding: 2px 6px;
    line-height: 1;
}

.x8h6t2dyqEu2ax40_IAg {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
    padding: 10px 12px;
    border-radius: 6px;
    border: 1px dashed rgba(251, 170, 105, 0.45);
    background: rgba(251, 170, 105, 0.08);
    color: #fbaa69;
    font-size: 11px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.15s ease, border-color 0.15s ease;
}

.x8h6t2dyqEu2ax40_IAg:hover {
    background: rgba(251, 170, 105, 0.14);
    border-color: rgba(251, 170, 105, 0.7);
}

.AHH7MGocQOmhT0PWjK1Y {
    font-size: 1rem;
}

.rnbPoGmqFTEU2tcjhqwb {
    flex-shrink: 0;
    min-height: 44px;
    border-radius: 8px;
    border: 2px dashed rgba(255, 255, 255, 0.22);
    background: rgba(0, 0, 0, 0.12);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px;
    transition: border-color 0.12s ease, background 0.12s ease;
}

.NtZTFLwMIJfas4kJ6LNh {
    border-color: rgba(251, 170, 105, 0.75);
    background: rgba(251, 170, 105, 0.1);
}

.hOQ0kSLgJNjujClQCs66 {
    font-size: 10px;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.42);
    text-align: center;
    pointer-events: none;
    letter-spacing: 0.03em;
}

.NtZTFLwMIJfas4kJ6LNh .hOQ0kSLgJNjujClQCs66 {
    color: rgba(251, 170, 105, 0.95);
}

.OQwQaofV8KawFa22ZLG1 {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    gap: 8px;
    min-height: 42px;
    border-radius: 6px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    background: rgba(42, 109, 244, 0.12);
    padding: 2px 4px 2px 8px;
}

.CTbkBwm0tejk102vqaw0 {
    width: 4px;
    align-self: stretch;
    border-radius: 3px;
    background: rgba(251, 170, 105, 0.55);
    flex-shrink: 0;
    margin: 6px 0;
}

.YhX95uZKuNIS4OLbiON5 {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 2px;
    background: transparent;
    border: none;
    color: inherit;
    cursor: pointer;
    text-align: left;
    padding: 4px 2px;
}

.YhX95uZKuNIS4OLbiON5:hover .g6mNx6RZdSMhfDTnTlTa {
    text-decoration: underline;
}

.g6mNx6RZdSMhfDTnTlTa {
    font-size: 11px;
    font-weight: 600;
    color: rgba(251, 252, 246, 0.95);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
}

.OxaxKbXPSU5zaO3v0A__ {
    font-size: 8px;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.45);
}

.GgnKmmaWpY73pdyMhMtb {
    flex-shrink: 0;
    width: 32px;
    border: none;
    background: transparent;
    color: rgba(255, 255, 255, 0.45);
    cursor: pointer;
    border-radius: 4px;
    align-self: center;
}

.GgnKmmaWpY73pdyMhMtb:hover {
    color: #fbfcf6;
    background: rgba(255, 255, 255, 0.08);
}

.B_PkhyQddmnJVeRcvKyX {
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 4px;
    margin-bottom: 8px;
    background-color: rgba(0, 0, 0, 0.18);
}

.bDVuWljge62LMfYlblwz {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    gap: 8px;
    padding: 8px 10px;
}

.FEZ_BR0V92Jg8tyPkIap {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
}

.iQqnUDhAxN3h_YHTvayv {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 8px;
    flex-wrap: wrap;
}

.iQqnUDhAxN3h_YHTvayv .ECcMOGPzCvLJ3vCNyMhw {
    flex: 1;
    min-width: 0;
}

.ECcMOGPzCvLJ3vCNyMhw {
    font-size: 11px;
    font-weight: 600;
    color: rgba(251, 252, 246, 0.92);
    line-height: 1.25;
    word-break: break-word;
}

.HDXaR1lB8OoHkST237Ao {
    cursor: pointer;
    color: rgba(251, 170, 105, 0.95);
    text-decoration: underline;
    text-decoration-color: rgba(251, 170, 105, 0.45);
    text-underline-offset: 2px;
}

.HDXaR1lB8OoHkST237Ao:hover {
    color: #fbaa69;
}

.srMliX3Myj1NG_LnPA3l {
    flex-shrink: 0;
    align-self: flex-start;
    background: transparent;
    border: 1px solid rgba(255, 255, 255, 0.22);
    border-radius: 4px;
    color: rgba(251, 252, 246, 0.92);
    padding: 4px 7px;
    cursor: pointer;
    font-size: 11px;
    line-height: 1;
}

.srMliX3Myj1NG_LnPA3l:hover {
    background: rgba(255, 255, 255, 0.08);
}

.bndcegJ_uvxs6eQ6yc5b {
    font-size: 9px;
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
    color: rgba(255, 255, 255, 0.5);
}

.B_PkhyQddmnJVeRcvKyX > .dqAzSdCZgpqnMzNvjdGL {
    margin-bottom: 0;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-top-color: transparent;
}

.B_PkhyQddmnJVeRcvKyX > .dqAzSdCZgpqnMzNvjdGL.ge1sjrKNf2bgeZY3k7D5 {
    border-top-color: rgba(42, 109, 244, 0.45);
}
`, "",{"version":3,"sources":["webpack://./src/components/menus/nodes/toolsMenuPackagePalette/ToolsMenuPackagePalette.module.css"],"names":[],"mappings":"AAAA,sFAAsF;;AAEtF;6CAC6C;AAC7C;IACI,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,+CAA+C;IAC/C,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,uCAAuC;AAC3C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,4CAA4C;IAC5C,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,yBAAyB;IACzB,2CAA2C;IAC3C,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,kFAAkF;AACtF;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uCAAuC;IACvC,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,2CAA2C;IAC3C,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,2CAA2C;IAC3C,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,aAAa;AACjB;;AAEA;+EAC+E;AAC/E;IACI,kBAAkB;IAClB,MAAM;IACN,UAAU;IACV,iBAAiB;IACjB,sCAAsC;IACtC,2CAA2C;IAC3C,yBAAyB;IACzB,2CAA2C;IAC3C,kBAAkB;IAClB,6CAA6C;IAC7C,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;IAChB,gCAAgC;IAChC,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,OAAO;IACP,aAAa;AACjB;;AAEA;IACI,2CAA2C;IAC3C,kBAAkB;IAClB,kBAAkB;IAClB,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,OAAO;IACP,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gCAAgC;IAChC,0BAA0B;IAC1B,gDAAgD;IAChD,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,gDAAgD;AACpD;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,uBAAuB;IACvB,2CAA2C;IAC3C,kBAAkB;IAClB,gCAAgC;IAChC,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,uBAAuB;IACvB,2CAA2C;IAC3C,kBAAkB;IAClB,gCAAgC;IAChC,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,8BAA8B;IAC9B,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,gCAAgC;IAChC,2CAA2C;IAC3C,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,oBAAoB;IACpB,+CAA+C;AACnD;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,sCAAsC;IACtC,8CAA8C;AAClD;;AAEA;gEACgE;AAChE;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,gBAAgB;IAChB,eAAe;IACf,iDAAiD;IACjD,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,0CAA0C;IAC1C,8BAA8B;IAC9B,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,0CAA0C;IAC1C,+BAA+B;IAC/B,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,2CAA2C;IAC3C,qCAAqC;IACrC,cAAc;AAClB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,2CAA2C;IAC3C,+BAA+B;AACnC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,UAAU;IACV,WAAW;IACX,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,cAAc;IACd,kDAAkD;AACtD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,cAAc;IACd,gBAAgB;IAChB,qBAAqB;IACrB,cAAc;IACd,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,QAAQ;IACR,YAAY;IACZ,uBAAuB;IACvB,6BAA6B;IAC7B,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;IACrC,uCAAuC;AAC3C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,gCAAgC;IAChC,oCAAoC;IACpC,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,4CAA4C;IAC5C,qCAAqC;IACrC,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,0DAA0D;AAC9D;;AAEA;IACI,qCAAqC;IACrC,sCAAsC;AAC1C;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,4CAA4C;IAC5C,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,0DAA0D;AAC9D;;AAEA;IACI,uCAAuC;IACvC,oCAAoC;AACxC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,kBAAkB;IAClB,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;IAClB,2CAA2C;IAC3C,oCAAoC;IACpC,wBAAwB;AAC5B;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,kBAAkB;IAClB,qCAAqC;IACrC,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,OAAO;IACP,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,QAAQ;IACR,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,gCAAgC;IAChC,eAAe;IACf,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,qCAAqC;AACzC;;AAEA;IACI,2CAA2C;IAC3C,kBAAkB;IAClB,kBAAkB;IAClB,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,uBAAuB;IACvB,QAAQ;IACR,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gCAAgC;IAChC,0BAA0B;IAC1B,gDAAgD;IAChD,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,uBAAuB;IACvB,2CAA2C;IAC3C,kBAAkB;IAClB,gCAAgC;IAChC,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,cAAc;IACd,6EAA6E;IAC7E,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;IACI,0CAA0C;AAC9C","sourcesContent":["/* Package palette panel (adjacent to built-in tools; dropdown opens toward canvas). */\n\n/* Trigger lives in the left rail (below the built-in nodes); the panel opens\n   into the strip to the right of the rail. */\n.packagePaletteRoot {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    flex-shrink: 0;\n    pointer-events: none;\n}\n\n.packagePaletteRoot > * {\n    pointer-events: auto;\n}\n\n.packagePaletteColumn {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    gap: 4px;\n    flex-shrink: 0;\n}\n\n.packagePaletteFooter {\n    flex-shrink: 0;\n    padding: 8px 10px 10px;\n    border-top: 1px solid rgba(255, 255, 255, 0.08);\n    background-color: #1E1F23;\n}\n\n.packageGetPackagesBtn {\n    width: 100%;\n    box-sizing: border-box;\n    min-height: 32px;\n    padding: 8px 10px;\n    border: none;\n    border-radius: 4px;\n    background-color: #FBAA69;\n    color: #1E1F23;\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: 0.4px;\n    line-height: 1.2;\n    cursor: pointer;\n    transition: background-color 0.15s ease;\n}\n\n.packageGetPackagesBtn:hover {\n    background-color: #fb9a4f;\n}\n\n.packageGetPackagesBtn:focus-visible {\n    outline: 2px solid rgba(251, 170, 105, 0.85);\n    outline-offset: 2px;\n}\n\n.packagePaletteTrigger {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 4px;\n    padding: 8px;\n    width: 100%;\n    box-sizing: border-box;\n    background-color: #1E1F23;\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    border-radius: 5px;\n    color: #fbfcf6;\n    cursor: pointer;\n    transition: border-color 0.15s ease, color 0.15s ease, background-color 0.15s ease;\n}\n\n.packagePaletteTrigger:hover {\n    background-color: #2c2d32;\n}\n\n.packagePaletteTriggerOpen {\n    border-color: rgba(251, 170, 105, 0.85);\n    color: #FBAA69;\n}\n\n.packagePaletteTriggerTop {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n}\n\n.packagePaletteTriggerIcon {\n    font-size: 1.25em;\n}\n\n.packagePaletteTriggerLabel {\n    font-size: 8px;\n    font-weight: 700;\n    letter-spacing: 0.6px;\n    text-transform: uppercase;\n    line-height: 1;\n}\n\n.packagePaletteTriggerCount {\n    font-size: 10px;\n    font-weight: 700;\n    color: #fbfcf6;\n    background-color: rgba(251, 170, 105, 0.25);\n    border-radius: 8px;\n    padding: 1px 6px;\n    line-height: 1.2;\n}\n\n.packagePaletteTriggerOpen .packagePaletteTriggerCount {\n    background-color: rgba(251, 170, 105, 0.35);\n    color: #fbfcf6;\n}\n\n.packagePaletteTriggerChevron {\n    font-size: 10px;\n    opacity: 0.85;\n}\n\n/* Absolutely positioned against #tools-palette-dock (the only positioned\n   ancestor) so the panel opens beside the built-in rail without widening it. */\n.packagePalettePanel {\n    position: absolute;\n    top: 0;\n    left: 100%;\n    margin-left: 10px;\n    width: min(380px, calc(100vw - 120px));\n    max-height: min(720px, calc(100vh - 170px));\n    background-color: #1E1F23;\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    border-radius: 5px;\n    box-shadow: 6px 10px 28px rgba(0, 0, 0, 0.45);\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n}\n\n.packagePalettePanelTitle {\n    flex-shrink: 0;\n    font-size: 9px;\n    font-weight: 700;\n    letter-spacing: 0.8px;\n    line-height: 1.2;\n    color: rgba(255, 255, 255, 0.55);\n    text-transform: uppercase;\n    text-align: left;\n}\n\n.packagePaletteRowAnchor {\n    margin: 0;\n    padding: 0;\n}\n\n.packagePaletteScroll {\n    overflow-y: auto;\n    padding: 6px 8px 10px;\n    flex: 1;\n    min-height: 0;\n}\n\n.packageDetails {\n    border: 1px solid rgba(255, 255, 255, 0.06);\n    border-radius: 4px;\n    margin-bottom: 8px;\n    background-color: rgba(0, 0, 0, 0.15);\n}\n\n.packageDetails:last-child {\n    margin-bottom: 0;\n}\n\n.packageSummary {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 8px;\n    cursor: pointer;\n    list-style: none;\n    padding: 8px 10px;\n    font-size: 11px;\n    font-weight: 600;\n    color: rgba(251, 252, 246, 0.92);\n    line-height: 1.3;\n}\n\n.packageSummary::-webkit-details-marker {\n    display: none;\n}\n\n.packageSummaryTitle {\n    flex: 1;\n    min-width: 0;\n    word-break: break-word;\n}\n\n.packageSummaryTitle[role=\"button\"] {\n    cursor: pointer;\n    color: rgba(251, 170, 105, 0.95);\n    text-decoration: underline;\n    text-decoration-color: rgba(251, 170, 105, 0.45);\n    text-underline-offset: 2px;\n}\n\n.packageSummaryTitle[role=\"button\"]:hover {\n    color: #fbaa69;\n    text-decoration-color: rgba(251, 170, 105, 0.85);\n}\n\n.packageSummaryFactoryPen {\n    flex-shrink: 0;\n    align-self: flex-start;\n    background: transparent;\n    border: 1px solid rgba(255, 255, 255, 0.22);\n    border-radius: 4px;\n    color: rgba(251, 252, 246, 0.92);\n    padding: 4px 7px;\n    cursor: pointer;\n    font-size: 11px;\n    line-height: 1;\n}\n\n.packageSummaryFactoryPen:hover {\n    background: rgba(255, 255, 255, 0.08);\n}\n\n.packageSummaryExportBtn {\n    flex-shrink: 0;\n    align-self: flex-start;\n    background: transparent;\n    border: 1px solid rgba(255, 255, 255, 0.22);\n    border-radius: 4px;\n    color: rgba(251, 252, 246, 0.92);\n    padding: 4px 7px;\n    cursor: pointer;\n    font-size: 11px;\n    line-height: 1;\n}\n\n.packageSummaryExportBtn:hover {\n    background: rgba(255, 255, 255, 0.08);\n}\n\n.packageSummaryRow {\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 8px;\n    width: 100%;\n}\n\n.packageSummaryTitleCluster {\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    gap: 8px;\n    flex: 1;\n    min-width: 0;\n}\n\n.packageSummaryTitleCluster .packageSummaryTitle {\n    flex: 1;\n    min-width: 0;\n}\n\n.packageSummaryCount {\n    flex-shrink: 0;\n    font-size: 9px;\n    font-weight: 700;\n    color: rgba(255, 255, 255, 0.55);\n    background-color: rgba(255, 255, 255, 0.08);\n    border-radius: 6px;\n    padding: 2px 6px;\n}\n\n.packageKindGrid {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    padding: 4px 6px 8px;\n    border-top: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.packageKindGridEdit {\n    padding-top: 8px;\n    padding-left: 8px;\n}\n\n.packageDetailsSelected {\n    border-color: rgba(42, 109, 244, 0.75);\n    box-shadow: 0 0 0 1px rgba(42, 109, 244, 0.35);\n}\n\n/* Header bar of the panel. Matches the dataset palette's `.panelHeader` so both\n   panels put their title on the same left inset and baseline. */\n.packagePaletteToolbar {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    min-height: 34px;\n    padding: 0 10px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n    align-items: center;\n    justify-content: flex-start;\n}\n\n.packageEditToggle {\n    font-size: 10px;\n    font-weight: 700;\n    letter-spacing: 0.5px;\n    text-transform: uppercase;\n    padding: 6px 12px;\n    border-radius: 4px;\n    border: 1px solid rgba(255, 255, 255, 0.2);\n    background: rgba(0, 0, 0, 0.2);\n    color: #fbfcf6;\n    cursor: pointer;\n}\n\n.packageEditToggle:hover {\n    background: rgba(255, 255, 255, 0.08);\n}\n\n.packageToolbarBtn {\n    font-size: 10px;\n    font-weight: 600;\n    letter-spacing: 0.3px;\n    padding: 6px 10px;\n    border-radius: 4px;\n    border: 1px solid rgba(255, 255, 255, 0.2);\n    background: rgba(0, 0, 0, 0.15);\n    color: rgba(251, 252, 246, 0.9);\n    cursor: pointer;\n}\n\n.packageToolbarBtn:hover {\n    background: rgba(255, 255, 255, 0.06);\n}\n\n.packageToolbarBtnPrimary {\n    font-size: 10px;\n    font-weight: 600;\n    letter-spacing: 0.3px;\n    padding: 6px 10px;\n    border-radius: 4px;\n    cursor: pointer;\n    border: 1px solid rgba(251, 170, 105, 0.45);\n    background: rgba(251, 170, 105, 0.12);\n    color: #fbaa69;\n}\n\n.packageToolbarBtnPrimary:hover {\n    background: rgba(251, 170, 105, 0.2);\n}\n\n.packageKindRow {\n    display: flex;\n    flex-direction: row;\n    align-items: stretch;\n    gap: 8px;\n    min-height: 45px;\n}\n\n.packageKindRowDrag {\n    width: 45px;\n    flex-shrink: 0;\n    cursor: grab;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 8px 0;\n    position: relative;\n    border-radius: 4px;\n    border: 1px solid rgba(255, 255, 255, 0.06);\n    background: rgba(0, 0, 0, 0.12);\n}\n\n.packageKindRowDragEdit {\n    overflow: visible;\n}\n\n.packageKindDeleteBtn {\n    position: absolute;\n    top: -7px;\n    left: -7px;\n    z-index: 2;\n    width: 20px;\n    height: 20px;\n    padding: 0;\n    border: none;\n    border-radius: 50%;\n    background: transparent;\n    color: #ff453a;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 20px;\n    line-height: 1;\n    filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.45));\n}\n\n.packageKindDeleteBtn:hover {\n    color: #ff6961;\n}\n\n.packageKindDeleteBtn:active {\n    transform: scale(0.94);\n}\n\n.packageKindDragIcon {\n    font-size: 1.5em;\n    color: #fbfcf6;\n}\n\n.packageKindDragBadge {\n    position: absolute;\n    bottom: 2px;\n    right: 2px;\n    font-size: 7px;\n    font-weight: 700;\n    letter-spacing: 0.3px;\n    color: #fbfcf6;\n    background-color: #2a6df4;\n    padding: 1px 3px;\n    border-radius: 3px;\n    line-height: 1;\n    pointer-events: none;\n}\n\n.packageKindRowDrag:active {\n    cursor: grabbing;\n}\n\n.packageKindRowMeta {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n    gap: 4px;\n    min-width: 0;\n    background: transparent;\n    border: 1px solid transparent;\n    border-radius: 4px;\n    color: inherit;\n    cursor: pointer;\n    padding: 4px 6px;\n    text-align: left;\n}\n\n.packageKindRowMeta:hover {\n    background: rgba(255, 255, 255, 0.06);\n    border-color: rgba(255, 255, 255, 0.08);\n}\n\n.packageKindRowLabel {\n    font-size: 11px;\n    font-weight: 600;\n    color: rgba(251, 252, 246, 0.92);\n    line-height: 1.2;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    max-width: 100%;\n}\n\n.packageKindCategoryChip {\n    font-size: 8px;\n    font-weight: 700;\n    letter-spacing: 0.4px;\n    text-transform: uppercase;\n    color: rgba(255, 255, 255, 0.68);\n    background: rgba(255, 255, 255, 0.1);\n    border-radius: 4px;\n    padding: 2px 6px;\n    line-height: 1;\n}\n\n.packageAddSectionRow {\n    width: 100%;\n    box-sizing: border-box;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-bottom: 8px;\n    padding: 10px 12px;\n    border-radius: 6px;\n    border: 1px dashed rgba(251, 170, 105, 0.45);\n    background: rgba(251, 170, 105, 0.08);\n    color: #fbaa69;\n    font-size: 11px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background 0.15s ease, border-color 0.15s ease;\n}\n\n.packageAddSectionRow:hover {\n    background: rgba(251, 170, 105, 0.14);\n    border-color: rgba(251, 170, 105, 0.7);\n}\n\n.packageAddSectionIcon {\n    font-size: 1rem;\n}\n\n.packageCanvasDropSlot {\n    flex-shrink: 0;\n    min-height: 44px;\n    border-radius: 8px;\n    border: 2px dashed rgba(255, 255, 255, 0.22);\n    background: rgba(0, 0, 0, 0.12);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 8px;\n    transition: border-color 0.12s ease, background 0.12s ease;\n}\n\n.packageCanvasDropSlotActive {\n    border-color: rgba(251, 170, 105, 0.75);\n    background: rgba(251, 170, 105, 0.1);\n}\n\n.packageCanvasDropSlotInner {\n    font-size: 10px;\n    font-weight: 600;\n    color: rgba(255, 255, 255, 0.42);\n    text-align: center;\n    pointer-events: none;\n    letter-spacing: 0.03em;\n}\n\n.packageCanvasDropSlotActive .packageCanvasDropSlotInner {\n    color: rgba(251, 170, 105, 0.95);\n}\n\n.packageStagedRow {\n    display: flex;\n    flex-direction: row;\n    align-items: stretch;\n    gap: 8px;\n    min-height: 42px;\n    border-radius: 6px;\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    background: rgba(42, 109, 244, 0.12);\n    padding: 2px 4px 2px 8px;\n}\n\n.packageStagedRowGlyph {\n    width: 4px;\n    align-self: stretch;\n    border-radius: 3px;\n    background: rgba(251, 170, 105, 0.55);\n    flex-shrink: 0;\n    margin: 6px 0;\n}\n\n.packageStagedRowMeta {\n    flex: 1;\n    min-width: 0;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n    gap: 2px;\n    background: transparent;\n    border: none;\n    color: inherit;\n    cursor: pointer;\n    text-align: left;\n    padding: 4px 2px;\n}\n\n.packageStagedRowMeta:hover .packageStagedRowLabel {\n    text-decoration: underline;\n}\n\n.packageStagedRowLabel {\n    font-size: 11px;\n    font-weight: 600;\n    color: rgba(251, 252, 246, 0.95);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    max-width: 100%;\n}\n\n.packageStagedRowHint {\n    font-size: 8px;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    color: rgba(255, 255, 255, 0.45);\n}\n\n.packageStagedRowRemove {\n    flex-shrink: 0;\n    width: 32px;\n    border: none;\n    background: transparent;\n    color: rgba(255, 255, 255, 0.45);\n    cursor: pointer;\n    border-radius: 4px;\n    align-self: center;\n}\n\n.packageStagedRowRemove:hover {\n    color: #fbfcf6;\n    background: rgba(255, 255, 255, 0.08);\n}\n\n.packageForkFamily {\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    border-radius: 4px;\n    margin-bottom: 8px;\n    background-color: rgba(0, 0, 0, 0.18);\n}\n\n.packageForkFamilyToolbar {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 8px;\n    padding: 8px 10px;\n}\n\n.packageForkFamilyToolbarText {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    min-width: 0;\n}\n\n.packageForkFamilyTitleRow {\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    gap: 8px;\n    flex-wrap: wrap;\n}\n\n.packageForkFamilyTitleRow .packageForkFamilyTitle {\n    flex: 1;\n    min-width: 0;\n}\n\n.packageForkFamilyTitle {\n    font-size: 11px;\n    font-weight: 600;\n    color: rgba(251, 252, 246, 0.92);\n    line-height: 1.25;\n    word-break: break-word;\n}\n\n.packageForkFactoryTitleInteractive {\n    cursor: pointer;\n    color: rgba(251, 170, 105, 0.95);\n    text-decoration: underline;\n    text-decoration-color: rgba(251, 170, 105, 0.45);\n    text-underline-offset: 2px;\n}\n\n.packageForkFactoryTitleInteractive:hover {\n    color: #fbaa69;\n}\n\n.packageForkFamilyFactoryPen {\n    flex-shrink: 0;\n    align-self: flex-start;\n    background: transparent;\n    border: 1px solid rgba(255, 255, 255, 0.22);\n    border-radius: 4px;\n    color: rgba(251, 252, 246, 0.92);\n    padding: 4px 7px;\n    cursor: pointer;\n    font-size: 11px;\n    line-height: 1;\n}\n\n.packageForkFamilyFactoryPen:hover {\n    background: rgba(255, 255, 255, 0.08);\n}\n\n.packageForkFamilySubtitle {\n    font-size: 9px;\n    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n    color: rgba(255, 255, 255, 0.5);\n}\n\n.packageForkFamily > .packageDetails {\n    margin-bottom: 0;\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n    border-top-color: transparent;\n}\n\n.packageForkFamily > .packageDetails.packageDetailsSelected {\n    border-top-color: rgba(42, 109, 244, 0.45);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"packagePaletteRoot": `YnmQxWUc9sxjM8m0RZmm`,
	"packagePaletteColumn": `MlB6ZpNJUBoPfXzsO0zY`,
	"packagePaletteFooter": `Ps1OUCo73VcvUnhrGBU3`,
	"packageGetPackagesBtn": `uWWp8DC_l6t3Mw9nBGDE`,
	"packagePaletteTrigger": `IPbLp4QWfsVYNxjSXozQ`,
	"packagePaletteTriggerOpen": `N3ANezycAzcqGXN7Yqo3`,
	"packagePaletteTriggerTop": `mAmXDMf6oBOLAp8Im1zy`,
	"packagePaletteTriggerIcon": `WVQsU7i3oHd5AYuNtwJa`,
	"packagePaletteTriggerLabel": `dyJbIyr77XYBbdhHk6pQ`,
	"packagePaletteTriggerCount": `eVSzGDeC4XielroWUBfQ`,
	"packagePaletteTriggerChevron": `fzeJtcUX8Xt4eQ62_MTg`,
	"packagePalettePanel": `i6SxHYiIgdMn3G8f4ysG`,
	"packagePalettePanelTitle": `b7848Epd0ZnlchDQZY9k`,
	"packagePaletteRowAnchor": `ezPg16Xe1L85ygmqQ1Xm`,
	"packagePaletteScroll": `JSVyvWpE6OP98JhxGAMz`,
	"packageDetails": `dqAzSdCZgpqnMzNvjdGL`,
	"packageSummary": `FWtB5GIVAtPY5mnsLELA`,
	"packageSummaryTitle": `McugiZ529ePknPEZpQfy`,
	"packageSummaryFactoryPen": `BQhb6gR3StA4sqStXt2r`,
	"packageSummaryExportBtn": `LPVi0GCT_JoDEW3K_Lhp`,
	"packageSummaryRow": `agQcZHlI4GDwOOT8k_hM`,
	"packageSummaryTitleCluster": `U6zpoH1n37k5SJpB4pog`,
	"packageSummaryCount": `ZpsrJINVLNISMG44PUGw`,
	"packageKindGrid": `t5mq2RzHLNsfbWcgDRVQ`,
	"packageKindGridEdit": `FycGImEz8qwdahcu35jw`,
	"packageDetailsSelected": `ge1sjrKNf2bgeZY3k7D5`,
	"packagePaletteToolbar": `iq3g6FF70YOZdNLGJKQB`,
	"packageEditToggle": `DuZbmPliiOWPewtNq_Kf`,
	"packageToolbarBtn": `fdhIUCw0mQf3xboK2Bj1`,
	"packageToolbarBtnPrimary": `yW6XRKGl8rrzGl8kA2_V`,
	"packageKindRow": `TguIX9_P1mqDfyc9bHe3`,
	"packageKindRowDrag": `K2y80C0udB3eVNwNQCTw`,
	"packageKindRowDragEdit": `J5HqIbTNNSKGDYmuWkbE`,
	"packageKindDeleteBtn": `rM8iF5Z5KjQLnnHTutlw`,
	"packageKindDragIcon": `lbLJ3nS7DpEUFt2kxb9x`,
	"packageKindDragBadge": `hQ1y1fTUT1CZ22sdFNnn`,
	"packageKindRowMeta": `SQJjSyR2k8POFlvKeTYT`,
	"packageKindRowLabel": `k04FpgQydeu5GAO53R0E`,
	"packageKindCategoryChip": `vLRsIeDKZLQOKkbPhr1P`,
	"packageAddSectionRow": `x8h6t2dyqEu2ax40_IAg`,
	"packageAddSectionIcon": `AHH7MGocQOmhT0PWjK1Y`,
	"packageCanvasDropSlot": `rnbPoGmqFTEU2tcjhqwb`,
	"packageCanvasDropSlotActive": `NtZTFLwMIJfas4kJ6LNh`,
	"packageCanvasDropSlotInner": `hOQ0kSLgJNjujClQCs66`,
	"packageStagedRow": `OQwQaofV8KawFa22ZLG1`,
	"packageStagedRowGlyph": `CTbkBwm0tejk102vqaw0`,
	"packageStagedRowMeta": `YhX95uZKuNIS4OLbiON5`,
	"packageStagedRowLabel": `g6mNx6RZdSMhfDTnTlTa`,
	"packageStagedRowHint": `OxaxKbXPSU5zaO3v0A__`,
	"packageStagedRowRemove": `GgnKmmaWpY73pdyMhMtb`,
	"packageForkFamily": `B_PkhyQddmnJVeRcvKyX`,
	"packageForkFamilyToolbar": `bDVuWljge62LMfYlblwz`,
	"packageForkFamilyToolbarText": `FEZ_BR0V92Jg8tyPkIap`,
	"packageForkFamilyTitleRow": `iQqnUDhAxN3h_YHTvayv`,
	"packageForkFamilyTitle": `ECcMOGPzCvLJ3vCNyMhw`,
	"packageForkFactoryTitleInteractive": `HDXaR1lB8OoHkST237Ao`,
	"packageForkFamilyFactoryPen": `srMliX3Myj1NG_LnPA3l`,
	"packageForkFamilySubtitle": `bndcegJ_uvxs6eQ6yc5b`
};
export default ___CSS_LOADER_EXPORT___;
